class SectionImageTextList extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['list']
  }

  setupListeners () {
    if (this.needsCarousel) {
      this.initialiseSlider()
    }
  }

  initialiseSlider () {
    const slider = this.querySelector('slider-component')

    if (slider && slider.init) {
      slider.init()

      this.dataset.initialised = true
    }
  }

  get needsCarousel () {
    if (this.els.slide.elements?.length > 4) {
      this.els.buttons.element?.classList.remove('slider-button--sml-hidden', 'slider-button--med-hidden', 'slider-button--lrg-hidden')
      return true
    } else if (this.els.slide.elements?.length > 3) {
      this.els.buttons.element?.classList.remove('slider-button--sml-hidden', 'slider-button--med-hidden')
      return true
    } else if (this.els.slide.elements?.length > 2) {
      this.els.buttons.element?.classList.remove('slider-button--sml-hidden')
      return true
    }
    return false
  }
}

if (!customElements.get('section-image-text-list')) {
  customElements.define('section-image-text-list', SectionImageTextList)
}
